import React from "react";
import ConfigParser from '../../../js/common/utility/configParser';
import './index.scss';
import SpeakerSection from "./speakerSection";

// =====================================================================================================
// Root class for Speaker widget
// =====================================================================================================
export default class Speaker extends React.Component {
    constructor(props) {
        super(props);

        const {config} = this.props;
        const parser = ConfigParser.toParser(config);

        const srcBaseUrl = this.getSrcBaseUrl(parser);
        const cfg = {
            speakerDataId: parser.parseString('speakerSheetId') || parser.parseString('speakerDataId'),
            registerUrl: parser.parseString('registerUrl', ''),
            apiUrl: parser.parseString('apiUrl', ''),
            apiBaseUrl: parser.parseString('apiBaseUrl', PubHub.APIHost + '/v1/bookmarks/types/'),
            srcUrl: parser.parseString('srcUrl', ''),
            srcBaseUrl: srcBaseUrl,
            title: parser.parseString('title', ''),
            speakerType: parser.parseString('speakerType', ''),
            sortBy: parser.parseString('sortBy', ''),
            registerMessage: parser.parseString('registerMessage', '', true),
            errorMessage: {
                status: parser.parseObject('errorMessage status', this.getDefaultStatusErrorMessage()),
            },
        };

        this.state = {
            config: cfg,
            registerRetry: 0,
        }
    }

    // =====================================================================================================
    // Initialize AOS due to AOS being used in lower order components
    // =====================================================================================================
    // componentDidMount() {
    //     AOS.init();
    // }

    render() {
        return (
            <SpeakerSection key={this.state.registerRetry} config={this.state.config} forceRefresh={this.forceRefresh}/>
        );
    }

    // =====================================================================================================
    // Create url endpoints based off of environment
    // =====================================================================================================
    getSrcBaseUrl(parser) {
        let srcBaseUrl = PubHub.env == "production" ? 'https://sheets.production.devnetcloud.com/agenda' : 'https://sheets.testing.devnetcloud.com/agenda'
        srcBaseUrl = parser.parseString('srcBaseUrl', srcBaseUrl);
        return srcBaseUrl.endsWith('/') ? srcBaseUrl : srcBaseUrl + '/';
    }

    getDefaultStatusErrorMessage() {
        return `<div>
            <p>1. Make you have already created smartsheets and the sheet ids are valid.</p>
            <p>2. Make sure you share both smartsheets with Haihua(haihxiao@cisco.com)</p>
            <p>3. If problem still exists, please contact UX & Apps team.</p>
        </div>`;
    }

    forceRefresh = () => {
        const { registerRetry } = this.state;
        if (registerRetry < 1) {
            this.setState({ registerRetry: registerRetry + 1 });
        }
    }
}


